export enum AppointmentFlowActionOperations {
    Book = "BOOK",
    Confirm = "CONFIRM",
    Cancel = "CANCEL",
    NoShow = "NO SHOW",
    CheckIn = "CHECK-IN",
    StartVisit = "START VISIT",
    Admit = "ADMIT",
    Open = "OPEN",
    CheckOut = "CHECK-OUT",
    CompleteVisit = "COMPLETE VISIT",
    Holding = "HOLDING"
}
